import { JsonEditorCommand } from "src/data/commands";

export function filterCommands(commands: JsonEditorCommand[], isPolicy?: boolean) {
    if (isPolicy) {
        const excludeCommands = ["rebootDevice", "shutdownDevice"];
        return commands.filter((cmd) => !excludeCommands.includes(cmd.name));
    }
    return commands;
}
